export const typeItems = [
  {
    key: 'TEXT',
    title: 'Teks',
    description: 'Menyimpan nilai kolom dalam bentuk teks maksimal 255 karakter.',
    icon: 'icon-outline_plus',
    isShow: true,
  },
  {
    key: 'NUMBER',
    title: 'Angka',
    description: 'Menyimpan nilai kolom dalam bentuk angka.',
    icon: 'icon-outline_plus',
    isShow: true,
  },
  {
    key: 'DATE',
    title: 'Tanggal',
    description: 'Memilih salah satu tanggal pada kalender yang telah tersedia.',
    icon: 'icon-outline_calendar',
    isShow: false,
  },
]